/** Platform roles have their own portals; they are never "on a job". */
export const PLATFORM_ROLES: readonly string[] = ['super_admin', 'support_staff', 'marketing_agency', 'affiliate'];

/**
 * Admins, users and custom-role members: the org roles that reach their jobs
 * through "My jobs" rather than the crew dashboard (#1456). Crew keep the crew
 * dashboard; platform roles keep their portals.
 */
export const isMyJobsRole = (role: string | null | undefined): role is string =>
  !!role && role !== 'crew' && !PLATFORM_ROLES.includes(role);

/** Jobs that keep "My jobs" in the sidebar; completed/cancelled ones do not. */
export const MY_JOBS_OPEN_STATUSES: readonly string[] = ['scheduled', 'in_progress', 'on_hold'];

/**
 * Whether the job page shows Clock in/out to an assigned admin, user or
 * custom-role member. Only open jobs take new hours (crew reach the clock
 * through today's jobs, so they never clock into a finished job either). A
 * punch already running on this job keeps the card so Clock out stays
 * reachable after the job is completed.
 */
export const showsJobClockCard = (
  jobId: string,
  status: string | null | undefined,
  openPunchJobId: string | null | undefined,
): boolean => (!!status && MY_JOBS_OPEN_STATUSES.includes(status)) || openPunchJobId === jobId;
